import type {
  SystemPrompt,
  SystemPromptFilter,
  SystemPromptStore,
} from '../../ports/system-prompts'
import type { Transport } from './transport'

export class HttpSystemPromptStore implements SystemPromptStore {
  constructor(private readonly t: Transport) {}

  list(filter?: SystemPromptFilter): Promise<SystemPrompt[]> {
    return this.t.json<SystemPrompt[]>('GET', '/v1/system-prompts', {
      query: {
        source: filter?.source,
        host: filter?.host,
        locale: filter?.locale,
        search: filter?.search,
      },
    })
  }

  get(id: string): Promise<SystemPrompt> {
    return this.t.json<SystemPrompt>('GET', `/v1/system-prompts/${id}`)
  }

  getActive(): Promise<SystemPrompt | null> {
    return this.t.json<SystemPrompt | null>('GET', '/v1/system-prompts/active')
  }

  setActive(id: string): Promise<SystemPrompt> {
    return this.t.json<SystemPrompt>('POST', `/v1/system-prompts/${id}/activate`)
  }

  create(input: Omit<SystemPrompt, 'id' | 'version' | 'updatedAt'>): Promise<SystemPrompt> {
    return this.t.json<SystemPrompt>('POST', '/v1/system-prompts', { body: input })
  }

  update(id: string, patch: Partial<SystemPrompt>): Promise<SystemPrompt> {
    return this.t.json<SystemPrompt>('PATCH', `/v1/system-prompts/${id}`, { body: patch })
  }

  async delete(id: string): Promise<void> {
    await this.t.request('DELETE', `/v1/system-prompts/${id}`)
  }
}
